import React, { Component } from 'react';
import styled from 'styled-components';
import { Panel, PanelTitle, BarTrack, BarFill } from './DashboardPanel';
import LineChart from './LineChart';
import BarChart from './BarChart';
import BarList from './BarList';
import { sum } from '../model/dashboardCalc';
import { PERIOD_LIST, PERIOD_TYPE } from '../model/heatPumpDevice';
import { SIDO_LIST } from '../../../commons/constants/sido/SIDO_LIST';

// 대시보드 탭: 소비 트렌드 · 운영 효율 · 지역/제조사별 현황
class OverviewSection extends Component {
  render() {
    const { period, powerSeries, sidoPowerList, vendorCountList, onChangePeriod } = this.props;
    const [values, labels] = powerSeries;
    // 지역별 누적 소비전력 (API 응답 시도코드 → 시도 약칭, 소비전력 큰 순, 시도코드가 없는 unknown 항목은 제외)
    const regionItems = sidoPowerList
      .map((x) => {
        const sido = SIDO_LIST.find((s) => s.code === String(x.sidoCode));
        return sido ? [sido.shortName, Number(x.totalConsPower) || 0] : null;
      })
      .filter(Boolean)
      .sort((a, b) => b[1] - a[1]);
    const regionTotal = sum(regionItems, ([, v]) => v);
    // 제조사별 등록 기기 수 (기기 수 많은 순)
    const makerItems = vendorCountList
      .map((x) => [x.vendor, Number(x.count) || 0])
      .sort((a, b) => b[1] - a[1]);
    const makerTotal = sum(makerItems, ([, v]) => v);

    return (
      <Wrap>
        <div className="dash-grid">
          <Panel>
            <PanelTitle>
              <h2>
                전력 소비 트렌드 <span className="live">● 실측 시연</span>
              </h2>
              <div className="chart-controls">
                {PERIOD_LIST.map((p) => (
                  <button
                    key={p.key}
                    type="button"
                    className={period === p.key ? 'active' : ''}
                    onClick={() => onChangePeriod(p.key)}
                  >
                    {p.label}
                  </button>
                ))}
              </div>
            </PanelTitle>
            {/* 시간별은 영역 차트, 일자별/월별은 막대 차트 */}
            {period === PERIOD_TYPE.HOUR ? (
              <LineChart id="powerChart" values={values} labels={labels} ariaLabel="소비전력 그래프" />
            ) : (
              <BarChart values={values} labels={labels} ariaLabel="소비전력 그래프" />
            )}
            <div className="chart-note">* 기간별 사용 전력량 단위 kWh</div>
          </Panel>

          <Panel>
            <PanelTitle>
              <h2>AI 실시간 운영 분석(준비중)</h2>
            </PanelTitle>
            {/* 준비중: 수치는 모두 '-' 로 표시 */}
            <div className="summary-row">
              <div className="summary-tile">
                <div className="t">평균 COP</div>
                <div className="v">-</div>
              </div>
              <div className="summary-tile">
                <div className="t">가동률</div>
                <div className="v">-</div>
              </div>
              <div className="summary-tile">
                <div className="t">운전 기기</div>
                <div className="v">-</div>
              </div>
            </div>
            <div className="heatcast-card">
              <div>
                <strong>✦ HEATCAST AI INSIGHT</strong>
                <p>
                  다음 24시간 전력수요 예측 및 예상 피크 분석
                  <br />
                  운전 최적화·DR 연계 의사결정 지원
                </p>
              </div>
              <div className="peak">
                <div className="peak-label">예상 피크</div>
                <b>-</b>
                <div className="peak-time">-</div>
              </div>
            </div>
            <div className="status-line">
              <span>상태별 기기</span>
              <span>
                운전 - · 대기 - · 점검 -
              </span>
            </div>
            <BarTrack height={12} className="status-bar">
              <BarFill background="linear-gradient(90deg, #48dba7, #4eabff)" style={{ width: '0%' }} />
            </BarTrack>
          </Panel>
        </div>

        <div className="dash-bottom">
          <Panel>
            <PanelTitle>
              <h2>지역별 소비전력</h2>
              <span>누적 kWh</span>
            </PanelTitle>
            {regionItems.length > 0 ? (
              <BarList items={regionItems} total={regionTotal} showRate />
            ) : (
              <div className="empty">누적 소비전력 데이터가 없습니다.</div>
            )}
          </Panel>
          <Panel>
            <PanelTitle>
              <h2>제조사별 운전 현황</h2>
              <span>전체 : {makerTotal.toLocaleString()}대</span>
            </PanelTitle>
            {makerItems.length > 0 ? (
              <BarList items={makerItems} total={makerTotal} digits={0} showRate />
            ) : (
              <div className="empty">운전 중인 기기 데이터가 없습니다.</div>
            )}
          </Panel>
        </div>
      </Wrap>
    );
  }
}

const Wrap = styled.div`
  .dash-grid {
    display: grid;
    grid-template-columns: 1.55fr 1fr;
    gap: 14px;
    margin-top: 14px;
  }
  .dash-bottom {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 14px;
    margin-top: 14px;
  }
  .live {
    color: #70bfff;
    font-size: 11px;
    margin-left: 7px;
    font-weight: 400;
  }
  .chart-controls {
    display: flex;
    gap: 5px;

    button {
      border: 0;
      background: #1b2a40;
      color: #9eb2cd;
      border-radius: 7px;
      padding: 7px 11px;
      font-size: 11px;
      cursor: pointer;

      &.active {
        background: #315b82;
        color: #fff;
      }
    }
  }
  .empty {
    padding: 20px 0;
    text-align: center;
    font-size: 12px;
    color: #8297b3;
  }
  .chart-note {
    font-size: 11px;
    color: #8297b3;
    margin-top: 5px;
  }
  .summary-row {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
  }
  .summary-tile {
    padding: 14px;
    background: #0c1728;
    border: 1px solid #24344c;
    border-radius: 11px;

    .t {
      color: #8fa5c2;
      font-size: 11px;
    }
    .v {
      font-size: 20px;
      font-weight: 700;
      margin-top: 8px;
      color: #edf3fc;

      small {
        font-size: 11px;
        font-weight: 400;
        color: #98a9c2;
      }
    }
  }
  .heatcast-card {
    margin-top: 16px;
    padding: 16px;
    border: 1px solid #66512e;
    background: linear-gradient(100deg, #352819, #1b2430);
    border-radius: 13px;
    display: flex;
    justify-content: space-between;
    gap: 12px;
    align-items: center;

    strong {
      color: #f3d18d;
    }
    p {
      margin: 7px 0 0;
      color: #b9b7b0;
      font-size: 12px;
      line-height: 1.5;
    }
    b {
      font-size: 23px;
      color: #f7d38c;
    }
    .peak {
      text-align: right;
    }
    .peak-label {
      font-size: 11px;
      color: #e6c88e;
    }
    .peak-time {
      font-size: 11px;
      color: #d1b77d;
    }
  }
  .status-line {
    display: flex;
    justify-content: space-between;
    gap: 8px;
    margin-top: 18px;
    color: #93a8c4;
    font-size: 12px;
  }
  .status-bar {
    margin-top: 10px;
  }

  @media (max-width: 1200px) {
    .dash-grid,
    .dash-bottom {
      grid-template-columns: 1fr;
    }
  }
  @media (max-width: 700px) {
    .dash-grid,
    .dash-bottom {
      grid-template-columns: minmax(0, 1fr);
      gap: 12px;
      margin-top: 12px;
    }
    .summary-row {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 8px;
    }
    .summary-tile {
      padding: 12px;
      .v {
        font-size: 18px;
      }
    }
    .heatcast-card {
      align-items: flex-start;
      flex-direction: column;
    }
  }
`;

export default OverviewSection;
